// Single source of truth for business details (NAP) used in page copy, head tags and JSON-LD.
// Keep name/address/phone identical everywhere — local SEO depends on it.

export const SITE_URL = 'https://flipready.co';

export const BUSINESS = {
  name: 'Flip Ready',
  phoneDisplay: '(540) 786-2834',
  phoneHref: 'tel:5407862834',
  phoneE164: '+1-540-786-2834',
  email: 'flipreadyFXBG@gmail.com',
  // Service-area business: the street address is the owner's home, so it is intentionally not published.
  address: {
    city: 'Fredericksburg',
    state: 'VA',
    zip: '22407',
  },
  hours: {
    label: 'Monday - Saturday',
    time: '8:00 AM - 6:00 PM',
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    opens: '08:00',
    closes: '18:00',
  },
  logoPath: '/flip-ready-logo-transparent.png',
  ogImagePath: '/og-image.jpg',
} as const;

export interface ServiceArea {
  name: string;
  /** Name and type used for schema.org areaServed */
  schemaName: string;
  schemaType: 'City' | 'AdministrativeArea' | 'Place';
  /** Page (or section) that covers this area */
  href: string;
  /** Short line shown in the homepage Service Areas grid */
  blurb: string;
  /** Link text for the area's page */
  linkText: string;
}

export const SERVICE_AREAS: ServiceArea[] = [
  {
    name: 'Fredericksburg',
    schemaName: 'Fredericksburg, VA',
    schemaType: 'City',
    href: '/office-cleaning-fredericksburg-va',
    blurb: 'Downtown offices, medical practices and the Route 3 and Route 1 corridors.',
    linkText: 'Office cleaning in Fredericksburg',
  },
  {
    name: 'Stafford County',
    schemaName: 'Stafford County, VA',
    schemaType: 'AdministrativeArea',
    href: '/commercial-cleaning-stafford-va',
    blurb: 'From Falmouth to Garrisonville Road and the offices near Quantico.',
    linkText: 'Commercial cleaning in Stafford',
  },
  {
    name: 'Spotsylvania County',
    schemaName: 'Spotsylvania County, VA',
    schemaType: 'AdministrativeArea',
    href: '/commercial-cleaning-spotsylvania-va',
    blurb: 'Cosner’s Corner, Harrison Crossing, Massaponax and Courthouse Road.',
    linkText: 'Commercial cleaning in Spotsylvania',
  },
  {
    name: 'King George',
    schemaName: 'King George County, VA',
    schemaType: 'AdministrativeArea',
    href: '/office-cleaning-king-george-va',
    blurb: 'Dahlgren-area contractors and offices along Route 3 and Route 301.',
    linkText: 'Office cleaning in King George',
  },
  {
    name: 'Caroline County',
    schemaName: 'Caroline County, VA',
    schemaType: 'AdministrativeArea',
    href: '/commercial-cleaning-caroline-county-va',
    blurb: 'Bowling Green, Ladysmith, Ruther Glen and Carmel Church.',
    linkText: 'Commercial cleaning in Caroline County',
  },
  {
    name: 'Falmouth',
    schemaName: 'Falmouth, VA',
    schemaType: 'City',
    href: '/commercial-cleaning-stafford-va',
    blurb: 'Offices around the Route 1 and Route 17 junction in Stafford County.',
    linkText: 'Cleaning in Falmouth (Stafford County)',
  },
  {
    name: 'Locust Grove',
    schemaName: 'Locust Grove, VA',
    schemaType: 'City',
    href: '/commercial-cleaning-spotsylvania-va',
    blurb: 'Businesses along the Route 3 corridor west of Spotsylvania.',
    linkText: 'Cleaning in Locust Grove and western Route 3',
  },
  {
    name: 'Northern Virginia',
    schemaName: 'Northern Virginia',
    schemaType: 'Place',
    href: '/#contact',
    blurb: 'Offices and commercial spaces north of Stafford, scheduled on request.',
    linkText: 'Ask about Northern Virginia',
  },
];
